import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeviceHubIcon(props: IconProps) {
    return <Icon {...props} iconKey={"device_hub"}/>
}
